import React, {
  FC,
} from 'react';
import { Img } from 'react-image';
import { CircularGreenCheck } from '../../../../../../../../assets/svg-image';
import { lang } from '../../../../../../../../lib/utils/utils';
import { LargeCabSelected } from '../../../../../../../../assets/base64Images/cab-size/Large-cab-selected';
import { LargeCabUnselected } from '../../../../../../../../assets/base64Images/cab-size/Large-cab-unselected';
import SquadSemiBoldText from '../../../../../../../../components/Text/SquadSemiBoldText';
import PingFangMediumText from '../../../../../../../../components/Text/PingFangMediumText';
import { WhiteClose } from '../../../../../../../../assets/svg-image/common';
import ColumnBottom from '../../../../../../../../components/Layout/ColumnBottom';
import Column from '../../../../../../../../components/Layout/Column';
import RowCenter from '../../../../../../../../components/Layout/RowCenter';

const LargeBox: FC<Props> = ({
  isEnglish,
  largeCabId,
  largeCabHasFreeBox,
  selectCabId,
  setSelectCabId,
  setShowQuestion,
}) => {
  return (
    <ColumnBottom
      style={{ marginLeft: 20 }}
      onClick={() => {
        if (largeCabHasFreeBox) {
          setSelectCabId(largeCabId);
          setShowQuestion(false);
        }
      }}
    >
      <div style={{ fontFamily: lang('Squad-SemiBold, Squad', 'PingFangSC-Medium, PingFang SC'), fontWeight: lang(600, 500), color: '#11202B', fontSize: 16 }}>{lang('Large', '加大')}</div>
      <Column style={{ marginTop: 8 }}>
        <Img src={LargeCabSelected} style={{ width: 147, height: 159, opacity: selectCabId === largeCabId ? 1 : 0 }} />
        <Img src={LargeCabUnselected} style={{ width: 147, height: 159, marginTop: -159, opacity: selectCabId !== largeCabId ? 1 : 0 }} />
      </Column>
      {
        largeCabHasFreeBox ? (
          <Img src={CircularGreenCheck} style={{ width: 36, height: 36, marginTop: -18, opacity: selectCabId === largeCabId ? 1 : 0 }} />
        ) : (
          <RowCenter style={{ width: 130, height: 36, borderRadius: 100, backgroundColor: '#F44336', marginTop: -18, border: '4px solid #11202B' }}>
            <img src={WhiteClose} style={{ width: 10, height: 10 }} />
            {
              isEnglish ? (
                <SquadSemiBoldText fontSize={12} lineHeight={12} color={'#FFFFFF'} marginTop={2} marginLeft={10}>
                  Unavailable
                </SquadSemiBoldText>
              ) : (
                <PingFangMediumText fontSize={12} lineHeight={12} color={'#FFFFFF'} marginTop={2} marginLeft={10}>
                  不可用的
                </PingFangMediumText>
              )
            }
          </RowCenter>
        )
      }
    </ColumnBottom>
  );
};

export interface Props {
  isEnglish: boolean;
  largeCabId: number;
  selectCabId?: number;
  setSelectCabId: (cabId: number) => void;
  setShowQuestion: (show: boolean) => void;
  largeCabHasFreeBox: boolean;
}

export default LargeBox;
